module.exports = __webpack_public_path__ + "assets/img/5e7a14da68eacf0dad30fbd71512c098.png";